import React from 'react';

interface Level2EmptyProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const Level2Empty = ({width = 500, height = 500, className}: Level2EmptyProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 500 500'
    fill='inherit'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    role='img'
    aria-label='Empty Level 2 Badge'
  >
    <g filter='url(#filter0_i_4102_1376)'>
      <path
        d='M235.173 36.2894C241.583 24.5688 258.417 24.5687 264.827 36.2894L328.017 151.828C332.67 160.335 339.664 167.329 348.171 171.982L463.709 235.172C475.43 241.582 475.43 258.416 463.709 264.826L348.171 328.016C339.664 332.669 332.67 339.663 328.017 348.17L264.827 463.708C258.417 475.429 241.583 475.429 235.173 463.708L171.983 348.17C167.33 339.663 160.336 332.669 151.829 328.016L36.2905 264.826C24.5699 258.416 24.5698 241.582 36.2905 235.172L151.829 171.982C160.336 167.329 167.33 160.335 171.983 151.828L235.173 36.2894Z'
        fill='inherit'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_4102_1376'
        x='27.5'
        y='27.4989'
        width='445'
        height='461'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='16' />
        <feGaussianBlur stdDeviation='32' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0' />
        <feBlend mode='normal' in2='shape' result='effect1_innerShadow_4102_1376' />
      </filter>
    </defs>
  </svg>
);
